module.exports = __webpack_public_path__ + "static/img/loading.b859f89.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 1